import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconMoney12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconMoney12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#Money12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M5.5 0a.5.5 0 0 1 .5.5v.632c.939.047 1.65.417 2.131.784a4 4 0 0 1 .728.726L8.9 2.7l.012.018.004.006.002.002v.001S8.92 2.728 8.5 3l.419-.273a.5.5 0 0 1-.836.548L4.875 2.208l3.207 1.067-.003-.005-.022-.03a3 3 0 0 0-.533-.529 2.8 2.8 0 0 0-1.721-.584 5 5 0 0 0-.928.08l-1.44-.478c.42-.299.953-.476 1.565-.554V.5a.5.5 0 0 1 .5-.5M5 10.896a4.75 4.75 0 0 1-1.992-.755 4 4 0 0 1-.678-.57 3 3 0 0 1-.22-.257l-.014-.02-.005-.006-.001-.003h-.001v-.001L2.5 9l-.412.283a.5.5 0 0 1 .822-.57l.004.006.024.03q.035.046.116.133c.11.114.279.272.514.43.466.315 1.196.641 2.235.641.664 0 1.197-.16 1.556-.452.342-.28.585-.727.585-1.45 0-.384-.192-.666-.618-.935-.442-.28-1.045-.485-1.733-.72l-.032-.01c-.666-.227-1.414-.484-1.99-.872C2.97 5.11 2.5 4.521 2.5 3.646c0-.81.313-1.475.936-1.917l1.439.479c-.37.072-.653.189-.86.336-.328.233-.515.577-.515 1.102 0 .443.21.756.63 1.039.445.3 1.058.517 1.753.754l.093.032c.636.216 1.34.455 1.884.8.595.376 1.084.93 1.084 1.78 0 .973-.342 1.726-.953 2.225-.546.445-1.254.643-1.99.673v.648a.5.5 0 0 1-1.001 0z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="Money12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconMoney12);
